// this file is automatically generated
	export const env = 'prod';
	export const version = 'v7.103.0'; // Sentry does not allow / in release name, e.g. release/v7.100 becomes release-v7.100
	export const buildDate = '1679314414126';
